import { Injectable } from '@angular/core';
import {SEED} from "@app/constans/constants";
import {jwtDecode} from "jwt-decode";
import {TokenInt} from "@app/interfaces";

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {
  private _selectedItem = null;
  private _userName: string = '';
  private _serial: string = '';
  constructor() {
    if(this.token && this.token !== '' && this.token !== ''){
      const decoded = jwtDecode<TokenInt>(this.token);
      this._userName = decoded.sub;
    }
  }

  get itemSelected() {
    return this._selectedItem;
  }

  set itemSelected(item: any) {
    this._selectedItem = item;
  }
  set token (token: any) {
    sessionStorage.setItem(SEED, token);
  }
  get token () {
    return sessionStorage.getItem(SEED);
  }

  set serial (serial: any) { this._serial = serial; }
  get serial () { return this._serial; }

  set userName (userName: any) { this._userName = userName; }
  get userName () { return this._userName; }

  clearToken() {
    sessionStorage.removeItem(SEED);
  }
}
